import type {DataRouterEditBlobPagePayload} from '@github-ui/code-view-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'

export const codeViewEditRoute = codeViewAppBuilder.createQueryRouteConfig('codeViewEditRoute', {
  path: '/:owner/:repo/edit/:branch/*',
  // when editing a file, we want to ensure we have the latest version of the file
  queries: [mainQuery<DataRouterEditBlobPagePayload>({navigationBehavior: 'network-first', encodeFetchPath: true})],
})
